export const Colors = {
  primary: "#ef4444",
  primaryDark: "#dc2626", 
  secondary: "#6b7280",
  background: "#ffffff",
  surface: "#f9fafb",
  text: "#111827",
  textSecondary: "#6b7280",
  border: "#e5e7eb",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6",
}

export const DarkColors = {
  primary: "#ef4444",
  primaryDark: "#dc2626",
  secondary: "#9ca3af",
  background: "#111827",
  surface: "#1f2937",
  text: "#f9fafb",
  textSecondary: "#9ca3af",
  border: "#374151",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6",
} 